"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.scrollTop = scrollTop;
exports.scrollLeft = scrollLeft;
exports.remove = remove;
exports.disableBodyScroll = disableBodyScroll;
exports.enableBodyScroll = enableBodyScroll;
exports.getContainer = void 0;

// import { contains } from '@utiljs/dom';
// /* 给元素绑定事件 */
// export const on = (function () {
//     if (document.addEventListener) {
//         return function (element: HTMLElement, event: any, handler: EventListenerOrEventListenerObject) {
//             if (element && event && handler) {
//                 element.addEventListener(event, handler, false);
//             }
//         };
//     } else {
//         return function (element: HTMLElement, event: any, handler: Function) {
//             if (element && event && handler) {
//                 // @ts-ignore
//                 element.attachEvent(`on${event}`, handler);
//             }
//         };
//     }
// }());
// /* 给元素去除事件绑定 */
// export const off = (function () {
//     if (document.removeEventListener) {
//         return function (element: HTMLElement, event: any, handler: EventListenerOrEventListenerObject) {
//             if (element && event) {
//                 element.removeEventListener(event, handler, false);
//             }
//         };
//     } else {
//         return function (element: HTMLElement, event: any, handler: Function) {
//             if (element && event) {
//                 element.detachEvent(`on${event}`, handler);
//             }
//         };
//     }
// }());
// /* 给元素绑定单次事件 */
// export const once = function (el: HTMLElement, event: any, fn: Function) {
//     const listener = function (...args) {
//         if (fn) {
//             fn.apply(this, args);
//         }
//         off(el, event, listener);
//     };
//     on(el, event, listener);
// };
// function addMouseEnterOrLeaveListener(el: HTMLElement, handler: Function, event: any) {
//     if (!el || typeof handler !== 'function' || (event !== 'mouseenter' && event !== 'mouseleave')) {
//         return;
//     }
//     const proxy = function (...args) {
//         const { relatedTarget } = args[0];
//         // 离开浏览器不会有relatedTarget
//         if (!relatedTarget || !contains(el, relatedTarget)) {
//             handler.apply(this, args);
//         }
//     };
//     // 多个元素可以绑定同一个事件，一个元素也可以绑定多个事件，所以需要保存 el-proxy-handler 之间的关系用于移除事件
//     let proxyList = el.__proxy_list;
//     if (!proxyList) {
//         proxyList = [];
//         el.__proxy_list = proxyList;
//     }
//     proxyList.push({
//         handler,
//         proxy,
//     });
//     el.addEventListener(event === 'mouseenter' ? 'mouseover' : 'mouseout', proxy);
// }
// function removeMouseEnterOrLeaveListener(el: HTMLElement, handler: Function, event: any) {
//     if (!el || typeof handler !== 'function' || (event !== 'mouseenter' && event !== 'mouseleave')) {
//         return;
//     }
//     const proxyList = el.__proxy_list;
//     if (!proxyList || !proxyList.length) {
//         return;
//     }
//     let proxyItem;
//     const len = proxyList.length;
//     for (let i = 0; i < len; i++) {
//         proxyItem = proxyList[i];
//         if (proxyItem.handler === handler) {
//             break;
//         }
//     }
//     if (!proxyItem || !proxyItem.proxy) {
//         return;
//     }
//     el.removeEventListener(event === 'mouseenter' ? 'mouseover' : 'mouseout', proxyItem.proxy);
// }
// /**
//  * 绑定mouseenter事件，使用mouseover实现
//  * @param el 绑定事件的元素
//  * @param handler 事件处理函数
//  */
// export function addMouseEnterListener(el: HTMLElement, handler: Function) {
//     addMouseEnterOrLeaveListener(el, handler, 'mouseenter');
// }
// /**
//  * 移除mouseenter事件，使用mouseover实现
//  * @param el 绑定事件的元素
//  * @param handler 事件处理函数
//  */
// export function removeMouseEnterListener(el: HTMLElement, handler: Function) {
//     removeMouseEnterOrLeaveListener(el, handler, 'mouseenter');
// }
// /**
//  * 绑定mouseleave事件，使用mouseout实现
//  * @param el 绑定事件的元素
//  * @param handler 事件处理函数
//  */
// export function addMouseLeaveListener(el: HTMLElement, handler: Function) {
//     addMouseEnterOrLeaveListener(el, handler, 'mouseleave');
// }
// /**
//  * 移除mouseleave事件，使用mouseout实现
//  * @param el 绑定事件的元素
//  * @param handler 事件处理函数
//  */
// export function removeMouseLeaveListener(el: HTMLElement, handler: Function) {
//     removeMouseEnterOrLeaveListener(el, handler, 'mouseleave');
// }

/**
 * 获取设置scrollTop
 * @param {Number} top 滚动值
 */
function scrollTop(top) {
  if (top == null) {
    return (document.scrollingElement || document.documentElement).scrollTop || document.body.scrollTop;
  }

  (document.scrollingElement || document.documentElement).scrollTop = top;
  document.body.scrollTop = top;
  return null;
}
/**
 * 获取设置scrollLeft
 * @param {Number} left 滚动值
 */


function scrollLeft(left) {
  if (left == null) {
    return (document.scrollingElement || document.documentElement).scrollLeft || document.body.scrollLeft;
  }

  (document.scrollingElement || document.documentElement).scrollLeft = left;
  document.body.scrollLeft = left;
  return null;
}

var getContainer = function getContainer(container) {
  var contain = typeof container === 'function' ? container() : container;
  return contain || document.body;
};
/**
 * 移除 DOM
 * @param {Node} el DOM 节点
 */


exports.getContainer = getContainer;

function remove(el) {
  if (el == null) {
    return;
  }

  if (el.remove) {
    el.remove();
  } else if (el.parentNode) {
    el.parentNode.removeChild(el);
  }
}
/**
 * 禁止Body滚动
 */


function disableBodyScroll() {
  document.body.style.overflow = 'hidden';
}
/**
 * 恢复Body滚动
 */


function enableBodyScroll() {
  document.body.style.overflow = '';
}